<template>
  <div class="card holder" style="cursor:pointer;" draggable="true"/>
</template>
<script>
export default {
  name: "Holder",
  data: function() {
    return {
      isDisplayed: false
    };
  }
};
</script>

<style scoped>
.holder {
  opacity: 0;
}
.display {
  display: block;
}
.notDisplay {
  display: none;
}
</style>
